<template>
  <section class="section hero">
    <div class="section__wrapper">
      <div class="section__content">
        <router-link :to="{ name: 'view-home' }">
          <img class="hero__heading" src="../assets/BTAB_svg.svg" alt="Britain Take A Bow">
        </router-link>
        <div v-if="isAdmin" class="hero__admin-nav">
          <p>Admin user</p>
          <p>
            <router-link :to="{ name: 'view-user-approval' }">Approve users</router-link>
          </p>
          <p>
            <router-link :to="{ name: 'view-upload' }">Upload</router-link>
          </p>
          <p>
            <router-link :to="{ name: 'view-home' }">Home</router-link>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-header',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['isAdmin']),
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// AppHeader.vue?6327bcdf